export default "__VITE_ASSET__DU3Ifeda__"